// extracted by mini-css-extract-plugin
export default {"main":"Recovery_main__ARdb9","error":"Recovery_error__wIRJH","errorsMessages":"Recovery_errorsMessages__gd+Pt"};